import { render, staticRenderFns } from "./Editcountry.vue?vue&type=template&id=85920dac&"
import script from "./Editcountry.vue?vue&type=script&lang=js&"
export * from "./Editcountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports